import {
  Component,
  ViewChild,
  Input,
  EventEmitter,
  Output,
  HostListener,
  ElementRef,
} from '@angular/core';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { Organization } from 'remarketing-angular-library';
import { get } from 'lodash';
import { QuoteWarningModalComponent } from '../quote-warning-modal/quote-warning-modal.component';

import { TranslocoDirective } from '@jsverse/transloco';
import { ActionSubmittedComponent } from 'src/shared/ui/comment/modal-actions/action-submitted/action-submitted.component';
import {
  ActionSubmittingComponent
} from '../../../shared/ui/comment/modal-actions/action-submitting/action-submitting.component';

@Component({
    selector: 'app-edit-dealership-modal',
    templateUrl: './edit-dealership-modal.component.html',
    styleUrls: ['./edit-dealership-modal.component.scss'],
    imports: [
        ModalComponent,
        TranslocoDirective,
        ActionSubmittedComponent,
        ActionSubmittedComponent,
        QuoteWarningModalComponent,
        ActionSubmittingComponent
    ],
    host: {
        '(document:keyup.escape)': 'handleKeyboardEvent($event)'
    }
})
export class EditDealershipModalComponent {
  @Input() tenantName: string;
  @Input() modalId = 'Edit-Dealership';
  @ViewChild(ModalComponent) modal: ModalComponent;

  @ViewChild('closeButton') closeButton: ElementRef;
  @ViewChild('submitSave') submitSave: ElementRef;
  @ViewChild('cancelSave') cancelSave: ElementRef;
  @ViewChild(QuoteWarningModalComponent) quoteWarningModalComponent: QuoteWarningModalComponent;

  @Input() dealerships: Organization[] = [];
  @Input() selectedDealership: Organization;
  @Input() quoteExist = false;
  @Output() selectedDealershipChange = new EventEmitter<Organization>();

  _selection: Organization;
  waitingResponse = false;
  successfulResponse = false;
  errorMessage: string | ((val: string | number) => string);
  isDealershipChanged = false;
  originalDealershipOeUUID: string;
  waitingForConfirmation = false;

  @HostListener('document:keyup.escape', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.modal?.modal?.isOpen) {
      this.modal.close();
    }
  }

  show(e): void {
    e.preventDefault();
    this.errorMessage = '';
    this.successfulResponse = false;
    this.waitingResponse = false;
    this._selection = this.selectedDealership;
    this.originalDealershipOeUUID = this.selectedDealership.oeUuid;
    this.modal.show();
  }

  close(): void {
    this.modal.close();
  }

  isSelectedDealership(dealership: Organization): boolean {
    return dealership.oeUuid === get(this, '_selection.oeUuid');
  }

  updateSelection(selection: Organization): void {
    this.isDealershipChanged = selection.oeUuid !== this.originalDealershipOeUUID;
    this._selection = selection;
  }

  submitDealership(): void {
    if (this.quoteExist) {
      this.waitingForConfirmation = true;
      this.quoteWarningModalComponent.show();
    }

    if (!this.waitingForConfirmation) {
      this.waitingResponse = true;
      this.selectedDealershipChange.emit(this._selection);
    }
  }

  setSuccessfulResponse() {
    this.waitingResponse = false;
    this.isDealershipChanged = false;
    this.successfulResponse = true;
  }

  // setErrorResponse(errorText = BuyErrors.MSG_BUY_002) {
  setErrorResponse(errorText: string) {
    this.errorMessage = errorText;
    this.waitingResponse = false;
    this.successfulResponse = false;
  }

  confirmation(e) {
    if (e) {
      this.waitingForConfirmation = false;
      this.quoteExist = false;
      this.submitDealership();
    } else {
      this.close();
    }
  }
}
